
import ExternalConfiguration from '../../external-configuration';

import './LoadingAnimation.css';

export default function LoadingAnimation( props) {
  return <img className='LoadingAnimation' alt='LoadingAnimation' src={`${ExternalConfiguration.ResourcesPath}/loading-spinning-bubbles.svg`} />;
}
